import { gql } from '@apollo/client'

/** Used by PackningPreviousPeriodNoticeModal (team /packning routes only). */
export const PACKNING_SELLING_PERIOD_NOTICE = gql`
  query PackningSellingPeriodNotice($teamId: String!) {
    team(id: $teamId) {
      id
      sellingPeriods {
        periods {
          id
        }
      }
    }
    memberSellingPeriod(teamId: $teamId) {
      start
      end
    }
  }
`
